import React from 'react'


const styles = {
  div: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translateX(-50%) translateY(-50%)'
  },
  title: {
    textAlign: 'center',
    fontSize: '30px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#66cc33'
  },
  description: {
    textAlign: 'center',
    fontSize: '20px',
    color: '#484848'
  }
}

const MidMsgComponent = props => (
  <div style={styles.div}>
    <h1 style={styles.title}>{props.title}</h1>
    <p style={styles.description}>{props.description}</p>
  </div>
);

export default MidMsgComponent;



// WEBPACK FOOTER //
// ./src/components/MidMsg/index.js